// @ts-nocheck
import styled from "@emotion/styled";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { ThemeContext } from "theme/themeContext";
import { switchComponent } from "theme/switch";
import { ReactComponent as ActivityDark } from "../../assets/svg/activityDark.svg";
import { ReactComponent as ActivityLight } from "../../assets/svg/activityLight.svg";
import { ReactComponent as RecordDark } from "../../assets/svg/recordDark.svg";
import { ReactComponent as RecordLight } from "../../assets/svg/recordLight.svg";
import { ReactComponent as Calendar } from "../../assets/svg/calendar.svg";
import { ReactComponent as Time } from "../../assets/svg/time.svg";
import moment from "moment";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { SwitchLock } from "components/Toggle/Toggle";
import { useTheme } from "@emotion/react";
import { DefaultLayout } from "layouts/DefaultLayout";
import { LoaderContainer } from "Routes";
import { Loader } from "components/Loader/Loader";
import parse from "html-react-parser";
import { useParams } from "react-router-dom";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  interaction: {
    mode: "index" as const,
    intersect: false,
  },
  stacked: false,
  aspectRatio: 1,
  scales: {
    y: {
      type: "linear" as const,
      display: true,
      position: "left" as const,
    },
    y1: {
      type: "linear" as const,
      display: true,
      position: "right" as const,
      grid: {
        drawOnChartArea: false,
      },
    },
  },
};

const Container = styled.div(({ theme }) => ({
  backgroundColor: theme.switch(
    theme.colors.dark.background,
    theme.colors.light.background
  ),
  color: theme.switch(theme.colors.dark.font, theme.colors.light.font),
  boxSizing: "border-box",
  padding: "35px",
  display: "flex",
  gap: "25px",
  minHeight: "100vh",
  "& a": {
    color: "#0B509F",
    textDecoration: "none",
  },
}));

const LeftContent = styled.div(() => ({
  width: "70%",
}));

const RightContent = styled.div(() => ({
  width: "30%",
}));

const NameBlock = styled.div(({ theme }) => ({
  width: "100%",
  padding: "25px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "10px",
  background: theme.switch(theme.colors.dark.main, theme.colors.light.main),
  boxShadow: theme.switch(
    0,
    "0px 0px 0px 0px rgba(207, 207, 207, 0.10), 0px 4px 9px 0px rgba(207, 207, 207, 0.10), 0px 17px 17px 0px rgba(207, 207, 207, 0.09), 0px 37px 22px 0px rgba(207, 207, 207, 0.05), 0px 67px 27px 0px rgba(207, 207, 207, 0.01), 0px 104px 29px 0px rgba(207, 207, 207, 0.00)"
  ),
  borderRadius: "10px",
  marginBottom: "20px",
}));

const KeyValues = styled.div(({ theme }) => ({
  width: "100%",
  display: "flex",
  gap: "15px",
  justifyContent: "space-between",
  padding: "25px",
  background: theme.switch(theme.colors.dark.main, theme.colors.light.main),
  boxShadow: theme.switch(
    0,
    "0px 0px 0px 0px rgba(207, 207, 207, 0.10), 0px 4px 9px 0px rgba(207, 207, 207, 0.10), 0px 17px 17px 0px rgba(207, 207, 207, 0.09), 0px 37px 22px 0px rgba(207, 207, 207, 0.05), 0px 67px 27px 0px rgba(207, 207, 207, 0.01), 0px 104px 29px 0px rgba(207, 207, 207, 0.00)"
  ),
  borderRadius: "10px",
}));

const KeyValueItem = styled.div(({ theme }) => ({
  flex: 1,
  padding: "12px",
  borderRadius: "10px",
  background: theme.switch(
    theme.colors.dark.purpleBg,
    theme.colors.light.purpleBg
  ),
  color: theme.switch(
    theme.colors.dark.fontSecondary,
    theme.colors.light.fontSecondary
  ),
}));

const KeyValueRank = styled.div(({ theme }) => ({
  color: theme.switch(theme.colors.dark.purple, theme.colors.light.purple),
  fontSize: "26px",
  fontWeight: "bold",
}));

const MainContent = styled.div(() => ({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  marginTop: "20px",
  gap: "15px",
}));

const TitleGlobal = styled.div(({ theme }) => ({
  fontSize: "30px",
  marginTop: "10px",
  marginBottom: "10px",
  fontWeight: "bold",
  color: theme.switch(theme.colors.dark.font, theme.colors.light.font),
}));

const Records = styled.div(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  minHeight: "214px",
  gap: "15px",
  justifyContent: "space-between",
  padding: "25px",
  marginBottom: "20px",
  background: theme.switch(theme.colors.dark.main, theme.colors.light.main),
  boxShadow: theme.switch(
    0,
    "0px 0px 0px 0px rgba(207, 207, 207, 0.10), 0px 4px 9px 0px rgba(207, 207, 207, 0.10), 0px 17px 17px 0px rgba(207, 207, 207, 0.09), 0px 37px 22px 0px rgba(207, 207, 207, 0.05), 0px 67px 27px 0px rgba(207, 207, 207, 0.01), 0px 104px 29px 0px rgba(207, 207, 207, 0.00)"
  ),
  borderRadius: "10px",
}));

const KeyValueName = styled.div(() => ({}));

const RecordsContainer = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  maxHeight: "350px",
  overflowY: "scroll",
}));
const ChartBlock = styled.div(() => ({
  height: "100%",
}));

const Toggle = styled.div(({ theme }) => ({
  display: "flex",
  borderRadius: "10px",
  overflow: "hidden",
  background: theme.switch(
    theme.colors.dark.purpleBg,
    theme.colors.light.purpleBg
  ),
  color: theme.switch(
    theme.colors.dark.fontSecondary,
    theme.colors.light.purple
  ),
}));

const ToggleBlockActive = styled.div(({ theme }) => ({
  padding: "8px 30px",
  borderRadius: "10px",
  color: "#fff",
  background: theme.switch(theme.colors.dark.purple, theme.colors.light.purple),
}));

const ToggleBlock = styled.div(({ theme }) => ({
  padding: "8px 30px",
  cursor: "pointer",
}));

const RecordBlock = styled.div(({ theme }) => ({
  padding: "15px",
  borderRadius: "10px",
  marginBottom: "20px",
  background: theme.switch(
    theme.colors.dark.secondary,
    theme.colors.light.secondary
  ),
}));

const RecordTitle = styled.div(({ theme }) => ({
  fontSize: "16px",
  color: theme.switch(theme.colors.dark.font, theme.colors.light.font),
  marginBottom: "10px",
  display: "flex",
  alignItems: "center",
  gap: "6px",
  "& svg": {
    filter:
      "invert(41%) sepia(3%) saturate(2938%) hue-rotate(129deg) brightness(99%) contrast(93%)",
  },
}));

const RecordDesc = styled.div(({ theme }) => ({
  color: theme.switch(
    theme.colors.dark.fontSecondary,
    theme.colors.light.fontSecondary
  ),
}));

const Event = styled.div(({ theme }) => ({
  paddingBottom: "20px",
  width: "396px",
  boxSizing: "border-box",
  borderRadius: "10px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",

  gap: "20px",
  background: theme.switch(theme.colors.dark.main, theme.colors.light.main),
}));

const TopBlock = styled.div(({ theme }) => ({
  width: "396px",
  height: "132px",
  color: theme.switch(
    theme.colors.dark.fontSecondary,
    theme.colors.light.fontSecondary
  ),
  "& img": {
    height: "100%",
    width: "392px",
  },
}));

const Avatar = styled.div(({ theme }) => ({
  objectFit: "contain",
  width: "396px",
  height: "132px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  color: theme.switch(
    theme.colors.dark.fontSecondary,
    theme.colors.light.fontSecondary
  ),
}));

const DateBlock = styled.div(({ theme }) => ({
  fontSize: "14px",
  display: "flex",
  paddingRight: "15px",
  marginBottom: "16px",
  gap: "30px",
  paddingLeft: "15px",
  alignItems: "center",
  "& span": {
    display: "flex",
    alignItems: "center",
    gap: "3px",
  },
  width: "100%",
  color: theme.switch(
    theme.colors.dark.fontSecondary,
    theme.colors.light.fontSecondary
  ),
}));

const TitleBlock = styled.div(({ theme }) => ({
  color: theme.switch(theme.colors.dark.purple, theme.colors.light.purple),
  fontSize: "20px",
  marginBottom: "7px",
  paddingLeft: "15px",
  paddingRight: "15px",
}));

const DescBlock = styled.div(({ theme }) => ({
  paddingLeft: "15px",
  paddingRight: "15px",
  color: theme.switch(
    theme.colors.dark.fontSecondary,
    theme.colors.light.fontSecondary
  ),
}));

const Condition = styled.div(({ theme }) => ({
  borderRadius: "10px",
  padding: "6px",
  background: theme.switch(
    theme.colors.dark.redSecondary,
    theme.colors.light.redSecondary
  ),
  fontSize: "10px",
  color: theme.switch(theme.colors.dark.red, theme.colors.light.red),
}));

const ActivitySvg = switchComponent(ActivityDark, ActivityLight);
const RecordSvg = switchComponent(RecordDark, RecordLight);

const dataFromArray = (elem) => {
  let datasets;
  datasets = [
    {
      label: "Dataset " + elem.variable,
      data: elem.data,
      backgroundColor: "#530BE5",
      borderColor: "#530BE5",
      options: {
        aspectRatio: 2,
      },
    },
  ];

  return {
    labels: elem.labels,
    datasets,
  };
};

export default function User() {
  const theme = useTheme();
  const params = useParams();
  console.log(theme);
  const id = Math.floor(Math.random() * 101);
  const context = useContext(ThemeContext);
  console.log(context);
  const [value, setValue] = useState([]);
  const [keyValues, setKeyValues] = useState([]);
  const [details, setDetails] = useState([]);
  const [components, setComponents] = useState([]);
  const [overview, setOverview] = useState("");
  const [loading, setLoading] = useState(true);
  const [loading1, setLoading1] = useState(true);
  const [records, setRecords] = useState([]);
  const [person, setPerson] = useState("");
  const [messages, setMessages] = useState([]);
  const [events, setEvents] = useState([]);

  const getRetailDemo = () => {
    setLoading(true);
    axios
      .get(
        "https://osiris-systems.co.uk/activity/api/apiActivityTrackerPerson/?id=" +
          params.id
      )
      .then(({ data }) => {
        setKeyValues(data.keyValue);
        setDetails(data.details);
        setOverview(data.overview);
        setRecords(data.news);
        setMessages(data.messages);
        setEvents(data.events);
        setPerson(data.person);
        setLoading(false);
        //@ts-ignore
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const getMessages = () => {
    setLoading1(true);
    axios
      .get(
        "https://osiris-systems.co.uk/activity/api/apiActivityTrackerMessages/?id=" +
          id
      )
      .then(({ data }) => {
        // setRecords(data.records);
        // setMessages(data.messages);
        // setLoading1(false);
        //@ts-ignore
      })
      .catch((error) => {
        setLoading1(false);
        console.log(error);
      });
  };

  useEffect(() => {
    getMessages();
    getRetailDemo();
  }, []);

  if (loading && loading1) {
    return (
      <LoaderContainer>
        <Loader />
      </LoaderContainer>
    );
  }

  return (
    <DefaultLayout>
      <Container>
        <LeftContent>
          <NameBlock>
            <span style={{ display: "flex", gap: "10px" }}>
              {person.name} {person.surname} |{" "}
              {person.conditions &&
                person.conditions.map((elem) => {
                  return <Condition>{elem}</Condition>;
                })}
            </span>
            <SwitchLock
              locked={theme.mode === "light" ? true : false}
              onClick={() => {
                context.toggleTheme();
              }}
            />
          </NameBlock>
          <KeyValues>
            {keyValues.map((elem) => {
              return (
                <KeyValueItem>
                  <KeyValueRank>{elem.value.toFixed(0)}</KeyValueRank>
                  <KeyValueName>{elem.variable}</KeyValueName>
                </KeyValueItem>
              );
            })}
          </KeyValues>

          <TitleGlobal>Overview</TitleGlobal>
          <NameBlock>
            <span>{parse(overview)}</span>
          </NameBlock>
          <TitleGlobal>Events</TitleGlobal>
          <MainContent>
            {events.map((elem) => {
              return (
                <Event key={elem.id}>
                  <TopBlock>
                    <Avatar>
                      <img src={"https://osirisfinance.com" + elem.img} />
                    </Avatar>
                  </TopBlock>
                  <div>
                    <DateBlock>
                      <span>
                        {" "}
                        <Calendar /> {moment(elem.date).format("dddd, Do MMMM")}
                      </span>
                      <span>
                        {" "}
                        <Time /> {elem.time}
                      </span>
                    </DateBlock>
                    <TitleBlock>{elem.title}</TitleBlock>
                    <DescBlock>{elem.description}</DescBlock>
                  </div>
                </Event>
              );
            })}
          </MainContent>
        </LeftContent>
        <RightContent>
          <Records>
            <TitleGlobal style={{ fontSize: "20px" }}>Messages</TitleGlobal>
            <RecordsContainer>
              {messages[0].map((elem) => {
                return (
                  <RecordBlock key={elem.id}>
                    <RecordTitle>
                      <RecordSvg />
                      Messages {elem.id}
                    </RecordTitle>
                    <RecordDesc>{parse(elem.text)}</RecordDesc>
                  </RecordBlock>
                );
              })}
            </RecordsContainer>
          </Records>
          <Records>
            <TitleGlobal style={{ fontSize: "20px" }}>News</TitleGlobal>
            <RecordsContainer>
              {records.map((elem) => {
                return (
                  <RecordBlock key={elem.id}>
                    <RecordTitle>
                      <RecordSvg />
                      Post{" "}
                      <span
                        style={{
                          width: "100%",
                          fontSize: "8px",
                          textAlign: "end",
                          color: "gray",
                        }}
                      >
                        {" "}
                        {moment(elem.createdAt).format(
                          "MMMM Do YYYY, h:mm:ss a"
                        )}
                      </span>
                    </RecordTitle>
                    <RecordDesc>{elem.content}</RecordDesc>
                  </RecordBlock>
                );
              })}
            </RecordsContainer>
          </Records>
        </RightContent>
      </Container>
    </DefaultLayout>
  );
}
